import { connect } from "react-redux";
import { compose, withHandlers, withState, lifecycle } from "recompose";
import { reduxForm } from "redux-form";
import {
  fetchUploadFileContent,
  fetchUploadFile,
  resetFileUploadPage,
  resetUploadFileContent,
} from "../../../redux/reducers/RuleImportFileReducer";
import { Alerts } from "../../../redux/constants/Values";
import { exportCSVFile } from "../../../apis/ruleImportFileAPI/normalizers";
import {rulesImportFilePath,rulesListPagePath} from "../../../utilities/pathHelpers";

/**
 *
 * @description {fetch values from store}
 */
export const mapStateToProps = (state) => ({
  isUploading: state.RuleImportFileReducer.isUploadingFile,
  fileName: state.RuleImportFileReducer.uploadFileData.name,
  fileUploadType: state.form.uploadFile,
  ruleImportAPIResponseData: state.RuleImportFileReducer.ruleImportAPIResponseData,
});

/**
 *
 * @description {On Change in File Attachment}
 */
export const onAttachmentChange = ({
  fetchUploadFileContent,
  setFileError,
  fileUploadType,
  resetUploadFileContent,
}) => (e) => {
  e.preventDefault();
  const files = e.target.files[0];
  if (files) {
    setFileError("");
  }
  
    let allowedExtensions = /(\.csv)$/i;
    if (allowedExtensions.exec(files.name) !== null) {
      fetchUploadFileContent(files);
    } else {
      //window.alert(Alerts.invalidFile);
      window.alert(Alerts.fileType);
      resetUploadFileContent("");
      //document.getElementsByClassName("custom-file-label")[0].innerText = "Upload file";
      // document.getElementById("custom-file").value = "";
    }
};

/**
 *
 * @description {On Submit File will Upload}
 */
export const onSubmit = ({ fetchUploadFile, setFileError, history }) => async (
  values
) => {
  let data = {
    fileType: values.entity,
  };
  if (!document.getElementById("custom-file").files.length) {
    setFileError("Please Select File Before Uploading !!");
  } else {
    fetchUploadFile(data).then((payload) => {
      if (payload.type === "FETCH_UPLOAD_FILE_REQUEST_SUCCESS") {
        window.alert(payload.payload.message);
        if (payload.payload.failedcount>0) {
        if(window.confirm("Successfully Updated: "+payload.payload.successcount+" rules "+
        "\nFailed To update: "+payload.payload.failedcount+" rules "+
        "\nDo you want to download/Export CSV file with detailed explaination?")){
          //let temp=payload.payload.ruleStatus;
          exportCSVFile(payload);
          history.go(rulesImportFilePath);
        // }
      } else {
        history.go(rulesImportFilePath);
      }
    } else {
      window.alert("All rules are successfully Updated!!!\n"+"Successfully Updated: "+payload.payload.successcount+" rules ");
    }
  } else {
      if (payload.payload.message === undefined) {
        window.alert(Alerts.uploadError);
      } else {
        if(window.confirm(payload.payload.message+"\nDo you want to download/Export CSV file with detailed explaination?")){
        //window.alert(payload.payload.message);
          exportCSVFile(payload);
          history.go(rulesImportFilePath)
        }
        //window.alert(payload.payload.message);
        //history.go("/rules-import-file");
      }
    }
  });
  }
};

export const backToListPage = ({ history }) => () => {
  history.push(rulesListPagePath);
};

/**
 *
 * @description {remove/unmount component values}
 */

export function componentWillUnmount() {
  this.props.resetFileUploadPage();
  //this.props.reset("uploadFile");
}

export default compose(
  connect(mapStateToProps, {
    fetchUploadFileContent,
    fetchUploadFile,
    resetFileUploadPage,
    resetUploadFileContent,
  }),
  withState("fileError", "setFileError", ""),
  withHandlers({ onAttachmentChange, onSubmit,backToListPage }),
  lifecycle({
    componentWillUnmount,
  }),
  reduxForm({
    form: "uploadFile",
    enableReinitialize: true,
  })
);
